import {Document, Packer, Paragraph, TextRun} from "docx";
import paypalicon from "../mainComponents/payment/assets/images/paypal-icon.png";
import visa from "../mainComponents/payment/assets/images/visa.png";
import master from "../mainComponents/payment/assets/images/mastercard.png";
import '../mainComponents/payment/assets/styles/paymentListStyleSheet.css';
import CurrencyExchangeRoundedIcon from '@mui/icons-material/CurrencyExchangeRounded';
import {MIME_TYPE_TO_EXTENSION, RTL_LANGUAGES} from "./constant";
import { styled } from '@mui/material/styles';
import Switch from '@mui/material/Switch';
import { PiHandCoins } from "react-icons/pi";
import Tooltip from "@mui/material/Tooltip";
/**
 * This function takes a date string as an argument, creates a new Date object from it,
 * and then uses the toLocaleDateString() method to format the date according to the
 * specified options
 * @param dateString
 * @returns {string}
 */
export function formatDate(dateString) {
    const date = new Date(dateString);
    const options = { month: '2-digit', day: '2-digit', year: 'numeric' };
    return date.toLocaleDateString('en-US', options);
}

/**
 * This function returns aligned text from right to the left for arabic and vis versa for other languages
 * specified options
 * @param language
 */
export const getScriptDirection = (language) => {

    return RTL_LANGUAGES.includes(language) ? 'rtl' : 'ltr';
};

/**
 * This function returns aligned text from right to the left for arabic and vis versa for other languages
 * specified options
 * @param language
 */
export const getScriptDirectionJoditEditor = (language) => {

    return RTL_LANGUAGES.includes(language) ? 'rtltext' : 'ltrtext';
};

/**
 * This function takes a float and decimal numbers as arguments, and returns a formated float
 * specified options
 * @param value
 * @param decimalPlaces
 */
export const formatFloat  = (value, decimalPlaces) => {
    return value.toFixed(decimalPlaces);
}

const statusMapper= {
    PENDING: "قيد الانتظار",
    COMPLETED: "مكتمل",
    FAILED: "فشل",
    REFUNDED: "تم الاسترداد",
}

export const getStatusIcon = (status, lang = null ) => {
    switch (status) {
        case 'COMPLETED':
            return lang ? (<span className="badge badge-sm badge-success">{lang === 'ar' ? statusMapper[status] : status}</span>) :
                <span className="badge badge-sm badge-success">{status}</span>;
        case 'FAILED':
            return lang ? (<span className="badge badge-sm badge-failed">{lang === 'ar' ? statusMapper[status] : status}</span>) :
                <span className="badge badge-sm badge-failed">{status}</span>;
        case 'REFUNDED':
            return lang ? (<span className="badge badge-sm badge-refunded">{lang === 'ar' ? statusMapper[status] : status}</span>) :
                <span className="badge badge-sm badge-refunded">{status}</span>;
        case 'PENDING':
        case 'pending':
            return lang ? (<span className="badge badge-sm badge-pending">{lang === 'ar' ? statusMapper[status] : status}</span>) :
                <span className="badge badge-sm badge-pending">{status}</span>;
        case 'REFUNDED-ICON':
            return <CurrencyExchangeRoundedIcon className="status-icon-style" style={{ border: '1px solid rgb(52, 71, 103)', color: 'rgb(52, 71, 103)' }} />;
        case 'paypal':
            return ( <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
                <img src={paypalicon} alt="paypal" style={{width:"2.5rem"}} />
            </div>)
        case 'credit-card':
            return (
                <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
                    <img src={visa} alt="Visa" style={{ height: '2rem' }} />
                    <img src={master} alt="Mastercard" style={{ height: '2rem' }} />
                </div>
            );

        case 'yaiglobal_credit':
            return (
                <Tooltip title="yaiglobal credits">
                <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
                       <PiHandCoins size={20} style={{marginLeft:"15px"}} />
                    </div>
                </Tooltip>
            )
        default:
            return null;
    }
};


/**
 * Returns the current date in the 'YYYY-MM-DD' format based on the local timezone.
 * @returns {string} Formatted date (YYYY-MM-DD)
 */
export const getFormattedTodayDate = () => {
    const today = new Date();
    return `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;
};

export const getFormattedFiveDaysAgoDate = () => {
    const today = new Date();
    const fiveDaysAgo = new Date();
    fiveDaysAgo.setDate(today.getDate() - 5);
    return `${fiveDaysAgo.getFullYear()}-${String(fiveDaysAgo.getMonth() + 1).padStart(2, '0')}-${String(fiveDaysAgo.getDate()).padStart(2, '0')}`;
};

export function downloadFile(content, fileName, contentType) {

    const a = document.createElement('a');
    const file = new Blob([content], {type: contentType});
    a.href = URL.createObjectURL(file);
    a.download = fileName;
    a.click();
}

/**
 * Converts time in "HH:MM:SS" format to total minutes.
 * @param {string} duration - Time duration in the format "HH:MM:SS".
 * @returns {number} Total minutes.
 */
export const formatTimeToMinutes = (duration) => {

    if (typeof duration != "string") {
        return 0;
    }
    const [hours, minutes, seconds] = duration.split(':').map(Number);
    return (hours * 60) + minutes + (seconds / 60);
};

export const downloadFileFromUrl = (fileName, url) => {

    fetch(url).then((response) => {
        response.blob().then((blob) => {

            // Creating new object of PDF file
            const fileURL =
                window.URL.createObjectURL(blob);

            // Setting various property values
            let alink = document.createElement("a");
            alink.href = fileURL;
            alink.download = fileName;
            alink.click();
        });
    });
};

const createSection = (headerText, pageNumber, bodyText, addPageBreak = true) => {
    const children = [];

    if (headerText.trim()) {
        if (pageNumber === 1) {
            children.push(new TextRun({
                text: `\n**${headerText}:**\n`,
                color: "0000FF",
                bold: true,
                size: 20,
            }));
            children.push(new TextRun({
                text: `-- Page ${pageNumber} --`,
                color: "808080",
                bold: false,
                size: 18,
            }));
        } else {
            children.push(new TextRun({
                text: `${headerText} -- Page ${pageNumber} --`,
                color: "808080",
                bold: false,
                size: 18,
            }));
        }
    }

    if (bodyText.trim()) {
        children.push(new TextRun({
            text: `\n${bodyText}`,
            break: 1,
        }));
    }

    let paragraph = new Paragraph({
        children,
        spacing: {
            after: 200,
        },
    })
    return addPageBreak ? [paragraph, new Paragraph({ pageBreakBefore: true })] : [paragraph];
};

const createPageSections = (paragraphsByPages, pages) => {
    const ocrPageSections = [];
    const translationPageSections = [];

    pages.forEach((page) => {
        if (page.content.trim() && paragraphsByPages.ocr_text) {
            ocrPageSections.push(
                ...createSection(`Extracted Text`, page.num, page.content)
            );
        }

        if (page.translated_text.trim() && paragraphsByPages.translated_text) {
            translationPageSections.push(
                ...createSection(`Translated Text`, page.num, page.translated_text)
            );
        }
    });

    return [ocrPageSections, translationPageSections];
};

const createOtherSections = (paragraphs) => {
    return paragraphs
        .filter(paragraph => paragraph.trim() !== "")
        .map((paragraph) => {
            const [header, ...rest] = paragraph.split('\n');
            const bodyText = rest.join('\n\n').trim();

            return new Paragraph({
                children: [
                    new TextRun({
                        text:  "\n" + header,
                        color: "0000FF",
                        bold: true,
                    }),
                    new TextRun({
                        text: bodyText,
                        break: 1,
                    }),
                ],
                spacing: {
                    after: 200,
                },
            });
        });
};

export const downloadDocFile = async (fileName, pages, paragraphsByPages, fields) => {
    const [ocrPageSections, translationPageSections] = createPageSections(paragraphsByPages, pages);

    const otherSections = createOtherSections(fields);

    const doc = new Document({
        sections: [
            {
                properties: {},
                children: [...ocrPageSections, ...translationPageSections, ...otherSections]
            }
        ]
    });

    Packer.toBlob(doc).then((blob) => {
        const a = document.createElement('a');
        a.href = URL.createObjectURL(blob);
        a.download = fileName;
        a.click();
    });
};

// Function to format data to URL query parameters
export const formatDataToUrlQueryParams = (data) => {
    const params = new URLSearchParams();
    Object.entries(data).forEach(([key, value]) => {
        if (value) {
            params.append(key, value);
        }
    });
    return params.toString();
};

/**
 *
 * @param data
 * @param type
 * @param title
 */
export const prepareDownload = (data, type, title) => {
    const blob = new Blob(data, { type: type });
    const link = document.createElement('a');
    const url = window.URL.createObjectURL(blob);
    link.href = url;
    let extension;
    if (title.toLowerCase().endsWith("epub")) {
        extension = "epub";
    } else if (type === "text/html") {
        extension = "html";
    } else {
        extension = MIME_TYPE_TO_EXTENSION[type] || "unknown";
    }
    link.setAttribute('download', `${title}.${extension}`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
}

/**
 *
 * @param title
 * @returns {`${string}_${string}`}
 */
export const getTitleWithDate = (title) => {
    const today = new Date();
    return `${title}_${today.toJSON()}`;
};

/**
 *
 * @param title
 * @returns {*}
 */
export const getTitleWithoutDate = (title) => {
    return title.replace(/_[^_]*$/, '')
};

export const getPasswordPattern = () => {
    return /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~])[A-Za-z\d!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]{8,}$/;
}

export const GradientSwitchStyle =  styled(Switch) (({ theme }) => ({
        '& .MuiSwitch-switchBase.Mui-checked': {
            color: '#fff',
            '& + .MuiSwitch-track': {
                background: 'linear-gradient(90deg, #98ec2d, #17ad37)',
                border: 'none',
            },
        },
        '& .MuiSwitch-switchBase': {
            '& + .MuiSwitch-track': {
                backgroundColor: '#d3d3d3',
                border: 'none',
            },
        },
        '& .MuiSwitch-thumb': {
            background: 'linear-gradient(90deg, #98ec2d, #17ad37)',
            border: 'none',
            boxShadow: 'none',
        }
    }));

export const formatDateTime = (dateTimeString) => {
    if (!dateTimeString) return '';

    try {
        const date = new Date(dateTimeString);
        if (isNaN(date.getTime())) return '';

        // Format: DD/MM/YYYY HH:MM
        return `${date.getDate().toString().padStart(2, '0')}/${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getFullYear()} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`;
    } catch (e) {
        console.error("Error formatting date:", e);
        return '';
    }
};

// Format duration from seconds to a readable format
export const formatDuration = (seconds) => {
    const hrs = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    const secs = Math.floor((seconds % 60));

    const parts = [];
    if (hrs > 0) parts.push(`${hrs} h`);
    if (mins > 0) parts.push(`${mins} min`);
    if (secs > 0 || parts.length === 0) parts.push(`${secs} s`);

    return `${parts.join(', ')}`;
};

/**
 *
 * @param input
 * @param numPages
 * @param t
 * @returns {{pages: (*|number)[], isValid: boolean, error}|{pages: *[], isValid: boolean, error}|{pages: (*|number)[], isValid: boolean, error: string}}
 */
export function parseCustomPageRange(input, numPages, t) {
    const Custompattern = /^\s*(\d+\s*-\s*\d+|\d+)\s*(,\s*(\d+\s*-\s*\d+|\d+))*\s*$/;
    if (!input) {
        return { pages: [], isValid: false, error: t("errors.customRequired") };
    }
    if (!Custompattern.test(input)) {
        return { pages: [], isValid: false, error: t("errors.customInvalid") };
    }
    const pages = input.split(",").flatMap((part) => {
        if (part.includes("-")) {
            const [start, end] = part.split("-").map(Number);
            if (isNaN(start) || isNaN(end) || start > end) return [];
            return Array.from({ length: end - start + 1 }, (_, i) => start + i);
        } else {
            const num = Number(part);
            return isNaN(num) ? [] : [num];
        }
    });
    const invalidPages = pages.filter((p) => p < 1 || p > numPages);
    if (invalidPages.length > 0) {
        return {
            pages,
            isValid: false,
            error: t("errors.pageOutOfRange", { max: numPages }),
        };
    }
    return { pages, isValid: true, error: "" };
}


/**
 *
 * @param digitizationProcesses
 * @returns {{totalError, hasCompleted: boolean, totalCompleted, totalPending, hasPending: boolean, hasRefund: boolean, totalRefunded, hasError: boolean}}
 */
export function summarizePayments(digitizationProcesses) {
    const calculateTotal = (items, field) =>
        items.reduce((sum, item) => sum + parseFloat(item[field] || 0), 0).toFixed(2);

    const grouped = {
        REFUNDED: [],
        PENDING: [],
        COMPLETED: [],
        FAILED: [],
    };

    digitizationProcesses.forEach(item => {
        const status = item.order_status;
        if (grouped[status]) {
            grouped[status].push(item);
        }
    });

    return {
        hasRefund: grouped.REFUNDED.length > 0,
        hasPending: grouped.PENDING.length > 0,
        hasCompleted: grouped.COMPLETED.length > 0,
        hasError: grouped.FAILED.length > 0,
        totalRefunded: calculateTotal(grouped.REFUNDED, "refund_amount"),
        totalPending: calculateTotal(grouped.PENDING, "cost"),
        totalCompleted: calculateTotal(grouped.COMPLETED, "cost"),
        totalError: calculateTotal(grouped.FAILED, "cost"),
    };
}

/**
 * @param {Blob} blob - The file data as a Blob
 * @param {string} fileName - Name to save the file as
 */
export function triggerFileDownload(blob, fileName) {
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');

    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();

    link.remove();
    window.URL.revokeObjectURL(url);
}


// ===== HTML STRUCTURE HELPERS =====
export const extractArticleInner = (html) => {
    if (!html) return "";
    const match = html.match(/<article[^>]*>([\s\S]*?)<\/article>/i);
    return match ? match[1] : html;
};


export const injectArticleInner = (fullHtml, articleInner) => {
    if (!fullHtml) return articleInner;
    return fullHtml.replace(
        /<article[^>]*>[\s\S]*?<\/article>/i,
        () => `<article>${articleInner}</article>`
    );
};


export const formatDateTimeShort = (dateTimeString) => {
    if (!dateTimeString) return '';

    try {
        const date = new Date(dateTimeString);
        if (isNaN(date.getTime())) return '';

        // Format: Sep 15, 2025 00:00
        const formattedDate = date.toLocaleDateString([], {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
        }).replace(',', '');

        const formattedTime = date.toLocaleTimeString([], {
            hour: '2-digit',
            minute: '2-digit',
            // hour12: false, // 24-hour format
        });

        return `${formattedDate}, ${formattedTime}`;
    } catch (e) {
        console.error("Error formatting date:", e);
        return '';
    }
};


export const extractStyles = (html) => {
    if (!html) return "";
    return [...html.matchAll(/<style[^>]*>([\s\S]*?)<\/style>/gi)]
        .map(match => match[1])
        .join("\n");
};
